/**
 * =====================================================================
 * REPORTS TAB - Fixed Assets Reports
 * =====================================================================
 *
 * This is extracted from the original AssetReports.tsx page.
 * For now, it imports and wraps the existing AssetReports component.
 * In the future, this can be refactored to a pure component.
 *
 * =====================================================================
 */

import React from 'react'
import { AdminUser } from '@/lib/authService'
import AssetReports from '@/pages/finance/AssetReports'

interface ReportsTabProps {
  user: AdminUser | null
  refreshTrigger: number
}

export default function ReportsTab({ user, refreshTrigger }: ReportsTabProps) {
  // For now, we'll render the existing AssetReports component
  // The header is already in the parent unified page, so we might want to hide it
  return <AssetReports user={user} />
}
